<template>
  <div>
    <v-container fluid class="white elevation-3 margen d-flex">
      <div class="d-flex justify-start">
        <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/maquinado" v-if="paso == 1">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="mx-auto">
        <h1>Nuevo Maquinado</h1>
      </div>
    </v-container>

    <v-stepper non-linear v-model="paso" class="ma-3">
      <v-stepper-header>
        <v-stepper-step editable step="1"> Materia Prima </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="2"> Producto </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="3"> Fin </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <!-- PASO NUMERO 1 -->
        <v-stepper-content step="1">
          <v-card class="mb-12 allB" color="grey lighten-3">
            <v-card-title>Datos Materia Prima:</v-card-title>
            <v-card-text class="black--text text-subtitle-1">
              <div class="d-flex">
                <v-autocomplete class="mx-1" label="Almacen Salida" v-model="almacenSeleccionado" :items="almacenes" item-text="NOMBRE" item-value="NOMBRE" return-object/>
                <v-autocomplete class="mx-1" label="Almacen Entrada (opcional)" v-model="almacenEntrada" :items="almacenes" item-text="NOMBRE" item-value="NOMBRE" return-object/>
              </div>
                <v-autocomplete class="mx-1" label="Asignar Proyecto" v-model="proyectoSeleccionado" :items="proyectos" :item-text="getTexto" item-value="FOLIO" return-object/>
              <!-- SECCION FECHA -->
              <v-menu
                v-model="modalFecha"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaSeleccionada"
                    label="Fecha salida"
                    prepend-icon="mdi-calendar"
                    light
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="fechaSeleccionada"
                  @input="modalFecha = false"
                  :min="minFecha[0]"
                >
                </v-date-picker>
              </v-menu>
              <!-- FIN SECCION FECHA -->

              <!-- SECCION ARTICULOS -->
              <v-row>
                <!-- PRIMERA TABLA -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                  <v-card-title>
                    <div>
                      <div>
                        Articulos
                        <v-btn
                          @click="InicializarArticulos"
                          small
                          text
                          class="success mx-2"
                          >Actualizar</v-btn
                        >
                      </div>
                    </div>

                    <v-divider dark class="ma-4" inline></v-divider>

                    <div class="d-flex">
                      <v-autocomplete
                        v-model="lineaSeleccionada"
                        :items="lineasArticulos"
                        item-text="NOMBRE"
                        item-value="NOMBRE"
                        label="Filtrar por Linea:"
                        return-object
                        class="mx-2 tamTexto"
                        hide-details=""
                      />
                      <v-text-field
                        v-model="buscador"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        class="tamTexto"
                      />
                    </div>
                  </v-card-title>

                  <v-data-table
                    class="elevation-1 grey lighten-2 tamTexto"
                    :headers="columnasTabla1"
                    :items="filtrarArticulos"
                    :search="buscador"
                    :loading="cargando"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 15, 20],
                    }"
                  >
                    <template v-slot:[`item.actionEditar`]="{ item }">
                      <v-btn
                        @click="AgregarArticulo(item)"
                        small
                        light
                        class="amber lighten-2"
                        style=""
                      >
                        Agregar
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <!-- TERMINA LA PRIMERA TABLA -->

                <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>

                <!-- SEGUNDA TABLA -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                  <v-card-title class="">
                    <span>Articulos Agregados </span>

                    <v-divider dark class="ma-4" inline></v-divider>

                    <v-text-field
                      v-model="buscador2"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                      class="tamTexto"
                    />
                  </v-card-title>

                  <v-data-table
                    class="elevation-1 grey lighten-2 tamTexto"
                    :headers="columnasTabla2"
                    :items="articulosAgregados"
                    :search="buscador2"
                  >
                    <template v-slot:[`item.AccionCantidad`]="{ item }">
                      <v-text-field
                        v-model="item.CANTIDAD"
                        label="Cantidad"
                        type="number"
                        min="1"
                      />
                    </template>

                    <template v-slot:[`item.AccionCosto`]="{ item }">
                      <v-text-field
                        v-model="item.COSTO"
                        label="Costo"
                        value="0.0"
                        prefix="$"
                        type="number"
                        min="0"
                      />
                    </template>

                    <template v-slot:[`item.AccionQuitar`]="{ item }">
                      <v-btn
                        @click="QuitarArticulo(item)"
                        small
                        text
                        dark
                        class="red darken-1"
                      >
                        Quitar
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <!-- TERMINA SEGUNDA TABLA -->
              </v-row>
              <!-- FIN SECCION ARTICULOS -->
            </v-card-text>
            <v-divider class="my-1"></v-divider>
          </v-card>
          <div class="d-flex justify-space-around">
            <v-btn text @click="cancelar"> Cancelar </v-btn>
            <v-btn color="primary" @click="paso = 2"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 1 -->

        <!-- PASO NUMERO 2 -->
        <v-stepper-content step="2"> 
          <v-card class="mb-12" color="grey lighten-3">
            <v-card-title>Seleccionar producto a crear:</v-card-title>
            <v-card-text class="black--text text-subtitle-1">

              <!-- SECCION ARTICULOS -->
              <v-row>
                <!-- PRIMERA TABLA -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                  <v-card-title>
                    <div>
                      <div>
                        Articulos
                        <v-btn
                          @click="InicializarArticulos"
                          small
                          text
                          class="success mx-2"
                          >Actualizar</v-btn
                        >
                      </div>
                    </div>

                    <v-divider dark class="ma-4" inline></v-divider>

                    <div class="d-flex">
                      <v-autocomplete
                        v-model="lineaSeleccionada"
                        :items="lineasArticulos"
                        item-text="NOMBRE"
                        item-value="NOMBRE"
                        label="Filtrar por Linea:"
                        return-object
                        class="mx-2 tamTexto"
                        hide-details=""
                      />
                      <v-text-field
                        v-model="buscador3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                        class="tamTexto"
                      />
                    </div>
                  </v-card-title>

                  <v-data-table
                    class="elevation-1 grey lighten-2 tamTexto"
                    :headers="columnasTabla1"
                    :items="filtrarArticulos"
                    :search="buscador3"
                    :loading="cargando"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 15, 20],
                    }"
                  >
                    <template v-slot:[`item.actionEditar`]="{ item }">
                      <v-btn
                        @click="AgregarProducto(item)"
                        small
                        light
                        class="amber lighten-2"
                        style=""
                      >
                        Agregar
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <!-- TERMINA LA PRIMERA TABLA -->

                <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>

                <!-- SEGUNDA TABLA -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                  <v-card-title class="">
                    <span>Producto Agregado </span>

                    <v-divider dark class="ma-4" inline></v-divider>

                    <v-text-field
                      v-model="buscador4"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                      class="tamTexto"
                    />
                  </v-card-title>

                  <v-data-table
                    class="elevation-1 grey lighten-2 tamTexto"
                    :headers="columnasTabla2"
                    :items="productosAgregados"
                    :search="buscador4"
                  >
                    <template v-slot:[`item.AccionCantidad`]="{ item }">
                      <v-text-field
                        v-model="item.CANTIDAD"
                        label="Cantidad"
                        type="number"
                        min="1"
                      />
                    </template>

                    <template v-slot:[`item.AccionCosto`]="{ item }">
                      <v-text-field
                        v-model="item.COSTO"
                        label="Costo"
                        value="0.0"
                        prefix="$"
                        type="number"
                        min="0"
                      />
                    </template>

                    <template v-slot:[`item.AccionQuitar`]="{ item }">
                      <v-btn
                        @click="QuitarProducto(item)"
                        small
                        text
                        dark
                        class="red darken-1"
                      >
                        Quitar
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <!-- TERMINA SEGUNDA TABLA -->
              </v-row>
              <!-- FIN SECCION ARTICULOS -->
            </v-card-text>
            <v-divider class="my-1"></v-divider>
          </v-card>
          <div class="d-flex justify-space-around">
            <v-btn text @click="paso=1"> Regresar </v-btn>
            <v-btn color="primary" @click="paso = 3"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 2 -->

        <!-- PASO NUMERO 3 -->
        <v-stepper-content step="3"> 
          <v-card>
            <v-card-title>Resumen: </v-card-title>
            <v-list v-if="articulosAgregados.length > 0 || productosAgregados.length > 0 || 
              almacenSeleccionado != null || fechaSeleccionada != '' || proyectoSeleccionado != null">
              <v-row>

                <v-col cols="12" sm="12" md="12">
                  <v-row class="mx-1">
                    <v-col cols="12" sm="12" md="4" v-if="fechaSeleccionada != ''">
                      -Fecha de Salida: {{fechaSeleccionada}}
                    </v-col>
                    <v-col cols="12" sm="12" md="4" v-if="almacenSeleccionado != null">
                      -Almacen Salida: {{ almacenSeleccionado.NOMBRE }}
                    </v-col>
                    <v-col cols="12" sm="12" md="4" class="noBreak" v-if="proyectoSeleccionado != null">
                      -Proyecto: {{ proyectoSeleccionado.FOLIO + '| ' +proyectoSeleccionado.NOMBRE }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="5" class="mx-2" v-if="articulosAgregados.length > 0">  
                  -Articulo/s de salida:
                  <v-list-item v-for="articulo in articulosAgregados" :key="articulo.ARTICULO_ID">
                    <v-list-item-content>
                      ● {{articulo.NOMBRE}} <br>
                      &ensp; Cantidad: {{articulo.CANTIDAD}}
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="mx-2" v-if="productosAgregados.length > 0">  
                  -Producto/s de entrada:
                  <v-list-item v-for="producto in productosAgregados" :key="producto.ARTICULO_ID">
                    <v-list-item-content>
                      ● {{producto.NOMBRE}}<br>
                      &ensp; Cantidad: {{producto.CANTIDAD}}
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
            <v-alert v-else class="my-2" :value="true" type="info" color="warning lighten-1" >
                Regresa para agregar informacion.
            </v-alert>
          </v-card>

          <div class="d-flex justify-space-around mt-4">
            <v-btn color="grey" dark @click="paso=2"> Regresar </v-btn>
            <v-btn color="primary" @click="crearMaquinado"> Continuar </v-btn>
          </div>
        </v-stepper-content>
        <!-- FIN PASO NUMERO 3 -->
      </v-stepper-items>


    </v-stepper>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {

      // --------- VARIABLES PARA VALIDACIONES ---------
      paso: 1,
      modalFecha:         false,
      minFecha:           "",

      articulos:          [],
      cargando:           false,
      buscador:           "",
      buscador2:          "",
      buscador3:          "",
      buscador4:          "",
      lineasArticulos:    [],
      lineaSeleccionada:  "",
      almacenes:          [],
      proyectos:[],

      columnasTabla1: [
        { text: "Clave", value: "CLAVE_MSP", width: "15%" },
        { text: "Articulo", value: "NOMBRE", filterable: false, width: "70%" },
        { text: "Agregar", sortable: false, value: "actionEditar", align: "right", width: "15%", },
      ],
      columnasTabla2: [
        { text: "Clave", value: "CLAVE_MSP", width: "15%" },
        { text: "Cantidad", sortable: false, value: "AccionCantidad",  },
        { text: "Articulo", value: "NOMBRE" },
        { text: "Precio", sortable: false, value: "AccionCosto", width:'20%' },
        { text: "Accion", sortable: false, value: "AccionQuitar", align: "right",},
      ],

      // --------- VARIABLES PARA MANDAR A BACK ---------
      fechaSeleccionada:  "",
      articulosAgregados: [],
      productosAgregados: [],
      almacenSeleccionado:null,
      almacenEntrada:null,
      proyectoSeleccionado:null,
    };
  },

  computed: {

    // ------------------------------------------------------------------------------
    ...mapGetters(["getFechaActual", "getURLAPI",'getUsuario']),

    // ------------------------------------------------------------------------------
    filtrarArticulos: function () {
      return this.articulos.filter((articulo) => {
        if (this.lineaSeleccionada == null) {
          return articulo;
        } else {
          return articulo.LINEA_ARTICULO_ID.toString().match(
            this.lineaSeleccionada.LINEA_ARTICULO_ID_MSP
          );
        }
      });
    },
    // ------------------------------------------------------------------------------
  },

  methods: {
    // ------------------------------------------------------------------------------
    async getAlmacenes(){
      this.almacenes = (await axios.get(`${this.getURLAPI}/Show/allStorage`)).data;
      // console.log(this.almacenes);
    },
    // ------------------------------------------------------------------------------
    async getProyectos(){
      this.proyectos = (await axios.get(`${this.getURLAPI}/Show/allProyect`)).data;
      // console.log(this.almacenes);
    },
    // ------------------------------------------------------------------------------
    getTexto(item){
      return `${item.FOLIO} | ${item.NOMBRE}`
    },
    // ------------------------------------------------------------------------------
    async InicializarArticulos() {
      this.cargando = true;
      this.articulos = [];

      this.articulos = (
        await axios.get(`${this.getURLAPI}/Show/allArticles`)
      ).data;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
      });

      this.cargando = false;
    },

    // ------------------------------------------------------------------------------
    async getLineasComboBox() {
      this.lineasArticulos = (
        await axios.get(`${this.getURLAPI}/Show/allLinea`)
      ).data;
    },

    // ------------------------------------------------------------------------------
    AgregarArticulo(articulo) {
      if (!this.articulosAgregados.includes(articulo)) {
        this.articulosAgregados.push(articulo);
        // this.$emit("setArticulos", this.articulosAgregados);
        console.log(this.articulosAgregados);
        console.log(JSON.stringify(this.articulosAgregados));
      }
    },

    // ------------------------------------------------------------------------------
    QuitarArticulo(articulo) {
      const index = this.articulosAgregados.indexOf(articulo);
      if (index > -1) {
        this.articulosAgregados.splice(index, 1);
      }
      console.log(this.articulosAgregados);
    },

    // ------------------------------------------------------------------------------
    AgregarProducto(articulo) {
      if (!this.productosAgregados.includes(articulo)) {
        this.productosAgregados.push(articulo);
        // console.log(this.articulosAgregados);
        // console.log(JSON.stringify(this.articulosAgregados));
      }
    },

    // ------------------------------------------------------------------------------
    QuitarProducto(articulo) {
      const index = this.productosAgregados.indexOf(articulo);
      if (index > -1) {
        this.productosAgregados.splice(index, 1);
      }
      console.log(this.productosAgregados);
    },

    // ------------------------------------------------------------------------------
    crearMaquinado(){
      // console.log(this.almacenSeleccionado.ALMACEN_ID);
      if( this.articulosAgregados.length > 0 && this.productosAgregados.length > 0 && 
        this.almacenSeleccionado && this.fechaSeleccionada != "" && this.proyectoSeleccionado)
      {
        let datosForm = new FormData();
        datosForm.append("ARTICULOS",       JSON.stringify(this.articulosAgregados));
        datosForm.append("PRODUCTOS",       JSON.stringify(this.productosAgregados));
        datosForm.append("FECHA",           this.fechaSeleccionada);
        datosForm.append("ALMACEN_ID",      this.almacenSeleccionado.ALMACEN_ID);
        datosForm.append("PROYECTO_ID",     this.proyectoSeleccionado.PROYECTO_ID);
        datosForm.append("USUARIO_CREADOR", this.getUsuario);
        if (this.almacenEntrada && this.almacenEntrada != null) {
          // console.log("ALMACEN ENTRADA",this.almacenEntrada.ALMACEN_ID);
          datosForm.append("ALMACEN_ENTRADA", this.almacenEntrada.ALMACEN_ID);
        }

        axios.post(`${this.getURLAPI}/Maquinado/crearMaquinado`, datosForm)
        .then( ({data}) =>{
          console.log(data);
          this.$root.vtoast.show(
          { message: data.MSG, color:data.STATUS=="OK" ? 'success darken-1' : "red darken-1", 
            timer:10000,       icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
          )
          if (data.STATUS == "OK") {
            this.$router.push("/maquinado");
          }
        })
        .catch( () => {

        })
      }
      else{
        this.$root.vtoast.show(
          { message: "Verifica los datos.", color: 'black', 
            timer:10000, icon: 'mdi-alert-circle-outline' } 
        )
      }
    },
    // ------------------------------------------------------------------------------


    // ------------------------------------------------------------------------------
    cancelar(){
      let close = confirm("¿Seguro que quieres cancelar el Maquinado?");
      if (close) {
        this.$router.push("/maquinado")
      }
    }
    // ------------------------------------------------------------------------------
  },

  created() {
    this.minFecha = this.getFechaActual.split(" ");
    this.InicializarArticulos();
    this.getLineasComboBox();
    this.getAlmacenes();
    this.getProyectos();
  },
};
</script>

<style>
.allB {
  border-style: solid;
  border-color: rgba(128, 128, 128, 0.349);
  border-width: 1px 1px 1px 1px;
}</style>
